module.exports = __webpack_public_path__ + "img/AZ.d917775a.svg";